/* eslint-disable */
import { take, takeEvery, call, fork, all, race, select } from 'redux-saga/effects';
import rpCookie from 'rp-cookie';
import {
    identify,
    trackLogin,
    trackUpgradeStarted,
    trackUpgradeCompleted,
    trackSubscriptionStarted,
    trackSubscriptionCompleted,
    trackSubscriptionViewed,
    trackSubscriptionDetailsViewed,
    trackSubscriptionUpgraded,
    trackSubscriptionSale,
    trackOrderCompleted,
    trackSubscriptionSaleAttempt,
    trackSubscriptionDetailsCompleted,
    trackRegister,
    TRAIT_ORDER_ID,
    TRAIT_PRODUCT_ID,
    TRAIT_PRODUCT_NAME,
    TRAIT_PRODUCT_PRICE,
    TRAIT_NAME,
    TRAIT_PRICE,
    TRAIT_REVENUE,
    TRAIT_STATUS,
    TRAIT_CHECKOUT_ID,
    TRAIT_EMAIL,
    TRAIT_USER_ID,
    TRAIT_TOTAL,
    TRAIT_COUPON,
    TRAIT_USER_NAME,
    TRAIT_PACKAGE,
    TRAIT_PACKAGE_ORIGIN,
    TRAIT_PACKAGE_DESTINATION,
    TRAIT_TS_CS,
    TRAIT_18_PLUST,
    trackSubscriptionSaleConfirmation,
    TRAIT_BETSLIP_ID,
    TRAIT_LOCATION,
    TRAIT_SUBSECTION,
} from 'rp-analytics';
import fetchUserInfo from './fetchUserInfo';
import fetchSessionStatus from './fetchSessionStatus';
import fetchUserServices from './fetchUserServices';
import { getActiveSubscription } from '../selectors';
import {
    PAYMENT_PAGE_LOAD_SUCCEEDED,
    PAYMENT_PAGE_LOAD_FAILED
} from '../components/PaymentPage/actions';
import {
    SUBSCRIPTION_UPGRADE_REQUESTED,
    SUBSCRIPTION_UPGRADE_SUCCEEDED,
    SUBSCRIPTION_RENEW_REQUESTED,
    SUBSCRIPTION_RENEW_SUCCEEDED
} from '../actions/subscriptions';
import {
    TRACK_LOGIN,
    TRACK_REGISTER,
    IDENTIFY_SIGNUP,
    TRACK_CHECKOUT_STARTED,
    TRACK_SUBSCRIPTION_STEP_COMPLETED,
    TRACK_PERSONAL_DETAILS_VIEWED,
    TRACK_PERSONAL_DETAILS_COMPLETED,
    TRACK_SUBSCRIPTION_SALE_ATTEMPT,
    TRACK_ORDER_COMPLETED
} from '../actions/tracking';
import getSession from './index'
const PACKAGE_FREE = 'Free';
const STATUS_SUBSCRIBE = 'subscribe';

export const getUserEmail = state => state.userInfo.data.email;
export const getSelectedSubscription = state => state.subscriptions.selected;
export const getConfirmation = state => state.confirmation;
export const getSelectedOption = state => state.subscriptions.selectedOption;

export function* identifySignUp() {
    while (true) {
        const {payload} = yield take(IDENTIFY_SIGNUP);
        const email = payload.email;
        const options = payload.customParameters;
        const userId = payload.clientUserId;
        const personal = {};
        const customParams = {};

        if(options['RP_isTermsAgreed'] == 1){
            Object.assign(customParams, {
                [TRAIT_TS_CS]: true,
            });
        }

        if(options['RP_18yo'] == 1){
            Object.assign(customParams, {
                [TRAIT_18_PLUST]: true,
            });
        }

        const firstName = payload.firstName;
        const lastName = payload.lastName;
        const phoneNumber = payload.phoneNumber;

        if (firstName !== '-' && lastName !== '-' && phoneNumber) {
            Object.assign(personal, {firstName, lastName, phoneNumber});
        }

        const props = {
            [TRAIT_USER_ID]: userId,
            [TRAIT_EMAIL]: email,
            [TRAIT_USER_NAME]: email,
            ...personal,
            ...customParams,
        };

        yield call(identify, props);
    }
}

export function* identifyAuthenticated() {
    yield take(PAYMENT_PAGE_LOAD_SUCCEEDED);

    const userEmail = yield select(getUserEmail);
    const identifyOptions = {
        [TRAIT_EMAIL]: userEmail,
    };
    const { sessionStatus, session } = yield call(getSession);

    if (session) {
        const userServices = yield call(fetchUserServices, sessionStatus.accountReference, session);
        if (userServices) {
            const activeSubscription = yield select(getActiveSubscription);

            if (activeSubscription) {
                identifyOptions[TRAIT_PACKAGE] = activeSubscription.ServiceTitle;
            }
        }
    }

    yield fork(identify, identifyOptions);
}

export function* identifyUnauthenticated() {
    yield take(PAYMENT_PAGE_LOAD_FAILED);
    yield fork(identify);
}

export function* identifySaga() {
    yield race({
        authenticated: call(identifyAuthenticated),
        unauthenticated: call(identifyUnauthenticated),
    });
}

export function* trackSubscriptionFlowSaga() {
    yield take(TRACK_CHECKOUT_STARTED);
    const { id, title, price } = yield select(getSelectedSubscription);

    yield call(trackSubscriptionStarted, {
        [TRAIT_ORDER_ID]: '',
        [TRAIT_PRODUCT_ID]: id,
        [TRAIT_PRODUCT_NAME]: title,
        [TRAIT_PRODUCT_PRICE]: price,
    });

    yield call(trackSubscriptionViewed, {
        [TRAIT_CHECKOUT_ID]: '',
    });
}

export function* trackDetailsViewedSaga() {
    const { payload: { checkoutId } } = yield take(TRACK_PERSONAL_DETAILS_VIEWED);
    yield call(trackSubscriptionDetailsViewed, {
        [TRAIT_CHECKOUT_ID]: checkoutId,
    });
}

export function* trackDetailsCompletedSaga() {
    const { payload: { checkoutId } } = yield take(TRACK_PERSONAL_DETAILS_COMPLETED);
    const { title, price } = yield select(getSelectedSubscription);
    yield call(trackSubscriptionDetailsCompleted, {
        [TRAIT_CHECKOUT_ID]: checkoutId,
        [TRAIT_PRODUCT_NAME]: title,
        [TRAIT_PRODUCT_PRICE]: price,
    });
}

export function* trackLoginSaga() {
    const { payload } = yield take(TRACK_LOGIN);
    yield call(trackLogin, {
        [TRAIT_EMAIL]: payload.email,
        [TRAIT_PACKAGE]: PACKAGE_FREE,
    });
}

export function* trackRegisterSaga() {
  const { payload } = yield take(TRACK_REGISTER);
  const options = payload.customParameters;

  const TRAIT_RACING_POST_CONTACT = 'racingPostContact';
  const allComunicationOptions = [
      options.RP_bloodstock,
      options.RP_competitions,
      options.RP_horseBetting,
      options.RP_horseNews,
      options.RP_sportBetting,
      options.membersBriefing,
      options.theFrontRunner,
      options.theUltimateDaily,
  ];

  const racingPostContact = allComunicationOptions.every(checkAllComunications) ? 1 : 0;

  yield call(trackRegister, {
      [TRAIT_EMAIL]: payload.email,
      [TRAIT_RACING_POST_CONTACT]: racingPostContact,
      ...options,
  });

  function checkAllComunications(option) {
    return Number(option) === 1;
  }
}

export function* trackSubscriptionStepCompleted() {
    const { payload: { checkoutId } } = yield take(TRACK_SUBSCRIPTION_STEP_COMPLETED);
    const subscriptionProps = yield select(getSelectedSubscription);
    let selectedSubscription = { [TRAIT_CHECKOUT_ID]: checkoutId }
    if (subscriptionProps && 'title' in subscriptionProps) {
        selectedSubscription = { ...selectedSubscription, [TRAIT_PRODUCT_NAME]: subscriptionProps.title }
    }

    if (subscriptionProps && 'price' in subscriptionProps) {
        selectedSubscription = { ...selectedSubscription, [TRAIT_PRODUCT_PRICE]: subscriptionProps.price }
    }

    yield call(trackSubscriptionCompleted, selectedSubscription);
}

export function* trackSubscriptionSaleAttemptSaga(payload) {
    const { title } = yield select(getSelectedSubscription);
    const options = payload.customParameters;
    const personal = {};

    const firstName = payload.firstName;
    const lastName = payload.lastName;
    const phoneNumber = payload.phoneNumber;

    if (firstName !== '-' && lastName !== '-' && phoneNumber) {
        Object.assign(personal, { firstName, lastName, phoneNumber });
    }

    yield call(trackSubscriptionSaleAttempt, {
        [TRAIT_PACKAGE]: title,
        ...options,
        ...personal,
    });
}

export function* orderCompletedSaga() {
    const { payload: { confirmation }} = yield take(TRACK_ORDER_COMPLETED);
    let confirmationData = {};

    if (confirmation) {
        confirmationData = yield select(getConfirmation);
    } else {
        const { id, title, price } = yield select(getSelectedSubscription);
        confirmationData.service = {};
        confirmationData.service.id = id;
        confirmationData.service.title = title;
        confirmationData.amount = price;
        confirmationData.sessionId = rpCookie.sharedPermanent.get('rp_guid');
        confirmationData.coupon = 'undefined';
    }
    const { sessionStatus, session } = yield call(fetchSessionStatus);

    if(session) {
        const userInfo = yield call(fetchUserInfo, sessionStatus.accountReference, session);

        if (userInfo) {
            yield call(trackSubscriptionSale, {
                [TRAIT_PACKAGE]: confirmationData.service.title,
                [TRAIT_PRICE]: confirmationData.amount,
                [TRAIT_REVENUE]: confirmationData.amount,
                [TRAIT_STATUS]: STATUS_SUBSCRIBE,
            });

            yield call(trackOrderCompleted, {
                [TRAIT_CHECKOUT_ID]: confirmationData.sessionId,
                [TRAIT_ORDER_ID]: confirmationData.sessionId,
                [TRAIT_PRODUCT_ID]: confirmationData.service.id,
                [TRAIT_TOTAL]: confirmationData.amount,
                [TRAIT_COUPON]: confirmationData.coupon === 'undefined' ? '' : confirmationData.coupon,
                [TRAIT_PRICE]: confirmationData.amount,
            });

            yield call(trackSubscriptionSaleConfirmation, {
                [TRAIT_PACKAGE.toLowerCase()]: confirmationData.service.title,
                [TRAIT_BETSLIP_ID]: null,
                [TRAIT_LOCATION]: 'Subscribe',
                [TRAIT_SUBSECTION]: null
            });
        }
    }
}

export function* trackUpgradeFlowSaga() {
    yield take(SUBSCRIPTION_UPGRADE_REQUESTED);
    const activeSubscription = yield select(getActiveSubscription);
    const { id, title, price } = yield select(getSelectedOption);
    const guid = rpCookie.sharedPermanent.get('rp_guid');

    yield call(trackUpgradeStarted, {
        [TRAIT_ORDER_ID]: guid,
        [TRAIT_PRODUCT_ID]: id,
        [TRAIT_PRODUCT_NAME]: title,
        [TRAIT_PRODUCT_PRICE]: price,
    });

    yield take(SUBSCRIPTION_UPGRADE_SUCCEEDED);

    yield call(trackUpgradeCompleted, {
        [TRAIT_CHECKOUT_ID]: guid,
        [TRAIT_ORDER_ID]: guid,
        [TRAIT_PRODUCT_ID]: id,
        [TRAIT_TOTAL]: price,
        [TRAIT_NAME]: title,
        [TRAIT_PRICE]: price,
    });
    yield call(trackSubscriptionUpgraded, {
        [TRAIT_PACKAGE_ORIGIN]: activeSubscription.ServiceTitle,
        [TRAIT_PACKAGE_DESTINATION]: title,
    });
}

export function* trackRenewFlowSaga() {
    yield take(SUBSCRIPTION_RENEW_REQUESTED);
    const { id, title, price } = yield select(getSelectedOption);
    const guid = rpCookie.sharedPermanent.get('rp_guid');

    yield call(trackUpgradeStarted, {
        [TRAIT_ORDER_ID]: guid,
        [TRAIT_PRODUCT_ID]: id,
        [TRAIT_PRODUCT_NAME]: title,
        [TRAIT_PRODUCT_PRICE]: price,
    });

    yield take(SUBSCRIPTION_RENEW_SUCCEEDED);

    yield call(trackUpgradeCompleted, {
        [TRAIT_CHECKOUT_ID]: guid,
        [TRAIT_ORDER_ID]: guid,
        [TRAIT_PRODUCT_ID]: id,
        [TRAIT_TOTAL]: price,
        [TRAIT_NAME]: title,
        [TRAIT_PRICE]: price,
    });
}

export default function* trackingSaga() {
    yield all([
        call(identifySaga),
        call(identifySignUp),
        call(trackLoginSaga),
        call(trackRegisterSaga),
        call(trackSubscriptionFlowSaga),
        call(trackDetailsViewedSaga),
        call(trackDetailsCompletedSaga),
        call(trackSubscriptionStepCompleted),
        call(orderCompletedSaga),
        call(trackUpgradeFlowSaga),
        call(trackRenewFlowSaga),
    ]);
}
